module.exports = __webpack_public_path__ + "img/003.f1d23038.jpg";